module.exports = "<div layout layout-align=\"space-between start\" class=\"order-totals-line-item order-totals-line-item--gift-card\"> <div class=\"gift-card-line-item__label\" flex=\"70\" layout=\"row\"> <span class=\"order-totals-line-item--gift-card__name\">{{$ctrl.giftCardName}}</span> </div> <div class=\"order-totals-line-item__value\" flex=\"30\"> <span>- {{($ctrl.appliedStoreCredit.amountUsedInCents) / 100 | currency}}</span> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/orderSummary/components/orderTotals/giftCardLineItem.html
// module id = 827
// module chunks = 0